import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_AlertMaintenance } from "../shared/data.service";

import { wsAlertMaintenanceEventAlertGetDataParm } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertGetDataInfo } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertSoundInfo } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertPriorityInfo } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertFrequencyInfo } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertAddParm } from "../shared/wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertUpdateParm } from "../shared/wsAlertMaintenanceEventAlertInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

@Component({
	selector: "app-root",
	templateUrl: "./addediteventalert.component.html",
	styleUrls: ["./addediteventalert.component.css"],
	providers: [ConfirmationService],
})
export class AddEditEventAlertComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_AlertMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public SchoolID: number = -1;
	public AlertID: number = -1;
	public isAdd: boolean = false;
	public isViewOnly: boolean = false;
	public selectedGroupValue: string = "2";

	public EventAlertData: wsAlertMaintenanceEventAlertGetDataInfo;

	public lstSoundItems: wsAlertMaintenanceEventAlertSoundInfo[] = [];
	public SelectedSound: wsAlertMaintenanceEventAlertSoundInfo;

	public lstPriorityItems: wsAlertMaintenanceEventAlertPriorityInfo[] = [];
	public SelectedPriority: wsAlertMaintenanceEventAlertPriorityInfo;

	public lstFrequencyItems: wsAlertMaintenanceEventAlertFrequencyInfo[] = [];
	public SelectedFrequency: wsAlertMaintenanceEventAlertFrequencyInfo;

	public rAlertCD: string = "";
	public rAlertDesc: string = "";
	public rMessage: string = "";
	public rMessagecolor: string = "#ebebeb;"; // Default to match border color until loaded

	public mp3Player: any = new Audio();

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.AlertID = this.dialogConfig.data.AlertID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsAlertMaintenanceEventAlertGetDataParm = {
			UserID: this.UserID,
			AlertID: this.AlertID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceEventAlertDataGet(parm).subscribe((data) => this.AlertMaintenanceEventAlertDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertDataGet_Complete(data: any) {
		this.EventAlertData = data;

		this.lstSoundItems = this.EventAlertData.SoundItems;
		this.lstPriorityItems = this.EventAlertData.PriorityItems;
		this.lstFrequencyItems = this.EventAlertData.FrequencyItems;

		this.rAlertCD = this.EventAlertData.AlertCD;
		this.rAlertDesc = this.EventAlertData.AlertDesc;
		this.rMessage = this.EventAlertData.Message;
		this.rMessagecolor = this.EventAlertData.FontColor;
		let tmpSchoolID = this.EventAlertData.SchoolID;

		if (this.isAdd == true) {
			//
			//	Add Mode
			//
			this.selectedGroupValue = "2"; // Current School Only
		} else {
			//
			//	Edit Mode
			//
			if (tmpSchoolID < 1) {
				this.selectedGroupValue = "1"; // All Schools

				if (this.UserLevelID == 3) {
					// School Level User
					this.isViewOnly = true;
				}
			} else {
				this.selectedGroupValue = "2"; // Current School Only
			}
		}

		//
		//	Select Default Sound
		//
		this.SelectedSound = this.lstSoundItems[0];

		this.lstSoundItems.forEach((item) => {
			if (item.SoundLibraryID == this.EventAlertData.SoundLibraryID) {
				this.SelectedSound = item;
			}
		});

		//
		//	Select Default Priority
		//
		this.SelectedPriority = this.lstPriorityItems[0];

		this.lstPriorityItems.forEach((item) => {
			if (item.PriorityID == this.EventAlertData.Priority) {
				this.SelectedPriority = item;
			}
		});

		//
		//	Select Default Frequency
		//
		this.SelectedFrequency = this.lstFrequencyItems[0];

		this.lstFrequencyItems.forEach((item) => {
			if (item.AlertFrequencyID == this.EventAlertData.AlertFrequencyID) {
				this.SelectedFrequency = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPriorityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPriorityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFrequencyChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFrequencyChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSoundChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSoundChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlay
	//
	//-----------------------------------------------------------------------------------------------------
	onPlay() {
		if (this.SelectedSound.SoundFile != "(NONE)") {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedSound.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStop
	//
	//-----------------------------------------------------------------------------------------------------
	onStop() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//

		if (this.rAlertCD.length < 1) {
			this.ErrorMessage = "Code must be entered.";
			return;
		}

		if (this.rAlertDesc.length < 1) {
			this.ErrorMessage = "Description must be entered.";
			return;
		}

		if (this.rMessage.length < 1) {
			this.ErrorMessage = "Message must be entered.";
			return;
		}

		//
		//	Validations Passed, Do the Insert or Update
		//
		if (this.AlertID < 1) {
			//
			//	INSERT
			//
			let parmDefinedByID: number;
			let parmSchoolID: number;

			if (this.selectedGroupValue == "1") {
				// All Schools
				parmDefinedByID = 4; // District User
				parmSchoolID = -1;
			} else {
				parmDefinedByID = 3; // School User
				parmSchoolID = this.SchoolID; // current school
			}

			let parm: wsAlertMaintenanceEventAlertAddParm = {
				AlertCD: this.rAlertCD,
				AlertDesc: this.rAlertDesc,
				Message: this.rMessage,
				FontColor: this.rMessagecolor,
				Priority: this.SelectedPriority.PriorityID,
				AlertFrequencyID: this.SelectedFrequency.AlertFrequencyID,
				SoundLibraryID: this.SelectedSound.SoundLibraryID,
				SchoolID: parmSchoolID,
				DefinedByID: parmDefinedByID,
			};

			this.isBusy = true;
			this.dataService.AlertMaintenanceEventAlertAdd(parm).subscribe((data) => this.AlertMaintenanceEventAlertAdd_Complete(data));
		} else {
			//
			//	UPDATE
			//
			let parm: wsAlertMaintenanceEventAlertUpdateParm = {
				AlertID: this.AlertID,
				AlertCD: this.rAlertCD,
				AlertDesc: this.rAlertDesc,
				Message: this.rMessage,
				FontColor: this.rMessagecolor,
				Priority: this.SelectedPriority.PriorityID,
				AlertFrequencyID: this.SelectedFrequency.AlertFrequencyID,
				SoundLibraryID: this.SelectedSound.SoundLibraryID,
			};

			this.isBusy = true;
			this.dataService.AlertMaintenanceEventAlertUpdate(parm).subscribe((data) => this.AlertMaintenanceEventAlertUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
